/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type DocChecksInterruptPartialUpdateRequest = {} | null | undefined;
export type DocChecksInterruptPartialUpdateResponse = any;

export type DocChecksInterruptPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc check.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/doc_checks/{id}/interrupt/
 *
 * ```yaml
 * operationId: doc_checks_interrupt_partial_update
 * tags:
 *   - doc_checks
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const docChecksInterruptPartialUpdateOperation = ({
  id,
  ...rest
}: DocChecksInterruptPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/doc_checks/${id}/interrupt/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/doc_checks/{id}/interrupt/' };
  };

/**
 * PATCH /dmx-server/doc_checks/{id}/interrupt/
 *
 * ```yaml
 * operationId: doc_checks_interrupt_partial_update
 * tags:
 *   - doc_checks
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const docChecksInterruptPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DocChecksInterruptPartialUpdateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = docChecksInterruptPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
